import React from 'react';
import type { MaybePaymentField, PaymentProviderSettings } from '../types';
import { parseProviderSettings } from './paymentUtils';

export default function usePaymentField(
  maybeData: MaybePaymentField,
): PaymentProviderSettings | null {
  return React.useMemo(() => parseProviderSettings(maybeData), [maybeData]);
}
